module.exports = __webpack_public_path__ + "img/remove.e6704056.svg";